/**
 * Validates a URL for Portal Cards.
 * Accepts valid URLs with a scheme (http/https) and host.
 */
export function validateUrl(url) {
    const errors = [];
    if (url.length === 0) {
        errors.push('URL must not be empty');
        return { valid: false, errors };
    }
    try {
        const parsed = new URL(url);
        if (!['http:', 'https:'].includes(parsed.protocol)) {
            errors.push('URL must use http or https protocol');
        }
        if (!parsed.hostname || parsed.hostname.length === 0) {
            errors.push('URL must have a valid host');
        }
    }
    catch {
        errors.push('URL format is invalid');
    }
    return { valid: errors.length === 0, errors };
}
//# sourceMappingURL=url.js.map